import * as React from 'react';
import { ApplicationMain } from 'src/styles/common';
import LoaderComponent from 'src/components/common/loader.component';
import { connect } from 'react-redux';
import { loginUser } from '../actions/action.userAuth';
import { getCountriesAssignedToUser } from '../actions/action.module';
import { SurveyReportWrapper } from 'src/styles/surveyreport';
// import SurveyReportsListComponent from 'src/components/reports/SurveyReportsListComponent';
import SurveyInternalReportsListComponent from 'src/components/reports/SurveyInternalReportsListComponent';


class SurveyInternalReportsListContainer extends React.Component<any, any> {
    state = {
        spacing: '16',
    };
    constructor(props: any) {
        super(props);
        this.loginUser = this.loginUser.bind(this);
      
    }

    componentDidMount() {
        // this.props.getCountriesAssignedToUser();
    }

    loginUser(data: any) {
        console.log("Main",data);
        this.props.loginUser(data)
    }

    render() {

        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />

                <SurveyReportWrapper>
                    <div className="pageContainer surveyReportScreen">

                        <SurveyInternalReportsListComponent 
                         />
                       
                    </div>
                </SurveyReportWrapper>

            </ApplicationMain>
        )
    }

}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        countryData: state.model.countryData
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loginUser: (data: any) => dispatch(loginUser(data)),
        getCountriesAssignedToUser: () => dispatch(getCountriesAssignedToUser()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SurveyInternalReportsListContainer);



// WEBPACK FOOTER //
// ./src/containers/SurveyInternalReportsListContainer.tsx